import type { NodeTypes } from '@mv/core/model/heim/richText';
import { cn } from '@mv/ui-kit/headless';
import { Html } from '@mv/ui-kit/primitives';
import { replacePlaceholders } from '../replacePlaceholders';
import type { RichTextContext } from '../RichText';

const IS_BOLD = 1;
const IS_ITALIC = 1 << 1;
const IS_STRIKETHROUGH = 1 << 2;
const IS_UNDERLINE = 1 << 3;
const IS_CODE = 1 << 4;
const IS_SUBSCRIPT = 1 << 5;
const IS_SUPERSCRIPT = 1 << 6;

export function TextNode({ node, nodeKey, context }: { node: NodeTypes; nodeKey: number; context: RichTextContext }) {
	const text = replacePlaceholders(node.text ?? '', context.replacements);
	if (!text) return null;

	const format = node.format ?? 0;
	return (
		<Html.Span
			key={nodeKey}
			className={cn(
				context.textClassName,
				format & IS_BOLD && 'font-body-bold font-bold',
				format & IS_ITALIC && 'italic',
				format & IS_STRIKETHROUGH && 'line-through',
				format & IS_UNDERLINE && 'underline',
				format & IS_CODE && 'font-mono text-sm',
				format & IS_SUBSCRIPT && 'align-sub text-xs',
				format & IS_SUPERSCRIPT && 'align-super text-xs',
			)}
		>
			{text}
		</Html.Span>
	);
}
